import React from "react";

/* ── Asset imports ── */
import HeroBgImg         from "../../asset/images/news/UpgradingTransformerRectifierHero-bg2.webp";
import ArticleImg        from "../../asset/images/news/article-32.webp";
import YoutubeIcon       from "../../asset/images/news/icon-youtube.svg";
import LinkedinIcon      from "../../asset/images/news/icon-linkedin.svg";
import BcSepIcon         from "../../asset/images/news/breadcrumb-separator.svg";
import ProfileIcon       from "../../asset/images/news/icon-profile.svg";
import CalendarIcon      from "../../asset/images/news/icon-calendar.svg";
import ClockIconImg      from "../../asset/images/news/icon-clock.svg";
import CommentsIcon      from "../../asset/images/news/icon-comments.svg";
import PreviousIcon      from "../../asset/images/news/icon-previous.svg";
import NextIcon          from "../../asset/images/news/icon-next.svg";
import FacebookIcon      from "../../asset/images/news/icon-facebook.svg";
import TwitterIcon       from "../../asset/images/news/icon-twitter.svg";
import LinkedinShareIcon from "../../asset/images/news/icon-linkedin-share.svg";

/* ── Recent post thumbnails ── */
import RecentImg1 from "../../asset/images/news/news-1.webp";
import RecentImg2 from "../../asset/images/news/news-2.webp";
import RecentImg3 from "../../asset/images/news/news-3.webp";
import RecentImg4 from "../../asset/images/news/news-4.webp";

const CSS = `
  @import url('https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;600;700;800&display=swap');

  *, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }
  .utr { font-family: 'Poppins', sans-serif; font-size: 14px; color: #202020; background: #fff; }

  /* ══ HERO (no border-top) ══ */
  .utr-hero {
    position: relative; width: 100%; height: 460px;
    overflow: hidden;
  }
  .utr-hero-bg {
    position: absolute; inset: 0;
    width: 100%; height: 100%;
    object-fit: cover; object-position: center right; display: block;
  }
  .utr-hero-overlay {
    position: absolute; inset: 0;
    // background: linear-gradient(
    //   to right,
    //   rgba(0,0,0,0.85) 0%,
    //   rgba(0,0,0,0.65) 38%,
    //   rgba(0,0,0,0.10) 100%
    // );
  }
  .utr-hero-content {
    position: absolute; inset: 0;
    display: flex; flex-direction: column; justify-content: center;
    padding: 0 102px;
    max-width: 1600px; margin: 0 auto; left: 0; right: 0;
  }
  .utr-hero-title {
    font-family: 'Poppins', sans-serif;
    font-size: 42px; font-weight: 600; color: #fff;
    line-height: 120%; margin-bottom: 15px; max-width: 575px;
  }
  .utr-hero-divider {
    width: 479px; height: 2px;
    background: #EB2019; border: none; margin-bottom: 15px;
  }
  .utr-hero-subtitle {
    font-family: 'Poppins', sans-serif;
    font-size: 16px; font-weight: 400; color: #fff;
    line-height: 160%; max-width: 479px;
  }

  /* ══ BREADCRUMB ══ */
  .utr-breadcrumb { width: 100%; padding: 40px 0 0 0; }
  .utr-breadcrumb-inner {
    max-width: 1600px; margin: 0 auto; padding: 0 102px;
    display: flex; align-items: center; flex-wrap: wrap;
  }
  .utr-bc-item {
    font-family: 'Poppins', sans-serif;
    font-size: 16px; font-weight: 500; color: #202020;
    text-decoration: none; display: flex; align-items: center; gap: 14px;
    transition: color 0.15s;
  }
  .utr-bc-item:hover { color: #EB2019; }
  .utr-bc-sep {
    display: flex; align-items: center; justify-content: center;
    width: 24px; height: 24px; border-radius: 50%;
    margin: 0 8px; flex-shrink: 0;
  }
  .utr-bc-sep img { width: 24px; height: 24px; display: block; }
  .utr-bc-item.active { color: #202020; font-weight: 500; }

  /* ══ INNER ══ */
  .utr-inner { max-width: 1600px; margin: 0 auto; padding: 0 102px; }

  /* ══ MAIN ══ */
  .utr-main-section { padding: 80px 0 120px 0; }
  .utr-main-row { display: flex; align-items: flex-start; gap: 89px; }

  /* ══ ARTICLE ══ */
  .utr-article { flex: 1; min-width: 0; }

  .utr-meta-bar {
    display: flex; align-items: center; flex-wrap: wrap; gap: 20px;
    margin-bottom: 30px;
  }
  .utr-meta-item {
    display: flex; align-items: center; gap: 8px;
    font-family: 'Poppins', sans-serif;
    font-size: 16px; font-weight: 400; color: #202020;
    border-right: 1px solid #7A7A7A; padding-right: 15px;
  }
  .utr-meta-item:last-child { border-right: none; padding-right: 0; }
  .utr-meta-item img { width: 24px; height: 24px; display: block; flex-shrink: 0; }

  .utr-article-title {
    font-family: 'Poppins', sans-serif;
    font-size: 32px; font-weight: 600; color: #202020;
    line-height: 140%; margin-bottom: 30px;
  }

  .utr-article-img {
    width: 100%; height: 450px;
    object-fit: cover; border-radius: 10px;
    display: block; margin: 45px 0 30px 0;
  }

  .utr-article-body {
    font-family: 'Poppins', sans-serif;
    font-size: 16px; font-weight: 400; color: #202020;
    line-height: 160%;
  }
  .utr-article-body p { margin-bottom: 20px; }
  .utr-article-body p:last-child { margin-bottom: 0; }

  .utr-h2 {
    font-family: 'Poppins', sans-serif;
    font-size: 16px; font-weight: 600; color: #202020;
    margin: 0px 0 0px 0; line-height: 160%; display: block;
  }

  /* Numbered ol list */
  .utr-article-body ol {
    list-style: none; margin: 0 0 30px 0; padding: 0;
    display: flex; flex-direction: column; gap: 20px;
    counter-reset: utr-counter;
  }
  .utr-article-body ol li {
    display: flex; align-items: flex-start; gap: 8px;
    font-size: 16px; font-weight: 400; color: #202020;
    line-height: 160%; counter-increment: utr-counter;
  }
  .utr-article-body ol li::before {
    content: counter(utr-counter) '.';
    font-weight: 600; color: #202020;
    flex-shrink: 0; min-width: 20px;
  }
  .utr-article-body ol li > span { flex: 1; }

  .utr-article-body strong { font-weight: 600; color: #202020; }

  .utr-red-link { color: #EB2019; text-decoration: underline; font-weight: 600; }
  .utr-red-link:hover { opacity: 0.8; }

  /* ══ BOTTOM ROW ══ */
  .utr-bottom-row {
    display: flex; align-items: center; justify-content: space-between;
    margin-top: 30px; padding-top: 30px;
    border-top: 1px solid #C7C7C7; flex-wrap: wrap; gap: 16px;
  }
  .utr-bottom-nav { display: flex; align-items: center; gap: 60px; }
  .utr-nav-btn {
    display: inline-flex; align-items: center; gap: 20px;
    font-family: 'Poppins', sans-serif;
    font-size: 20px; font-weight: 500; color: #202020;
    text-decoration: none; background: none; border: none;
    cursor: pointer; transition: color 0.15s;
  }
  .utr-nav-btn:hover { color: #EB2019; }
  .utr-nav-btn img { width: 40px; height: 40px; display: block; }

  .utr-share-icons { display: flex; align-items: center; gap: 20px; }
  .utr-share-icon {
    display: flex; align-items: center; justify-content: center;
    width: 40px; height: 40px; border-radius: 50%;
    text-decoration: none; flex-shrink: 0; transition: opacity 0.15s;
  }
  .utr-share-icon:hover { opacity: 0.85; }
  .utr-share-icon img { width: 44px; height: 44px; display: block; }

  /* ══ SIDEBAR ══ */
  .utr-sidebar { flex: 0 0 475px; }
  .utr-sidebar-block { margin-bottom: 60px; }
  .utr-sidebar-title {
    font-family: 'Poppins', sans-serif;
    font-size: 24px; font-weight: 600; color: #202020;
    margin-bottom: 30px; padding-bottom: 20px;
    border-bottom: 1px solid #EB2019; line-height: 120%;
  }
  .utr-recent-list { display: flex; flex-direction: column; gap: 30px; }
  .utr-recent-item {
    display: flex; align-items: flex-start; gap: 12px;
    text-decoration: none; color: #202020;
  }
  .utr-recent-item:hover .utr-recent-title { color: #EB2019; }
  .utr-recent-img {
    flex: 0 0 200px; height: 120px;
    object-fit: cover; border-radius: 6px; display: block;
  }
  .utr-recent-body { flex: 1; min-width: 0; }
  .utr-recent-title {
    font-family: 'Poppins', sans-serif;
    font-size: 16px; font-weight: 400; color: #202020;
    line-height: 160%; transition: color 0.15s;
    display: -webkit-box; -webkit-line-clamp: 3;
    -webkit-box-orient: vertical; overflow: hidden;
  }
  .utr-social-icons { display: flex; align-items: center; gap: 30px; }
  .utr-social-icon {
    display: flex; align-items: center; justify-content: center;
    width: 40px; height: 40px; border-radius: 6px; overflow: hidden;
    text-decoration: none; transition: opacity 0.15s;
  }
  .utr-social-icon:hover { opacity: 0.8; }
  .utr-social-icon img { width: 44px; height: 44px; object-fit: contain; display: block; }

  /* ══ RESPONSIVE — TABLET ══ */
  @media (max-width: 768px) {
    .utr-hero             { height: 350px; }
    .utr-hero-content     { padding: 0 32px; }
    .utr-hero-title       { font-size: 30px; }
    .utr-hero-divider     { width: 100%; max-width: 479px; }
    .utr-breadcrumb       { padding: 24px 0 0 0; }
    .utr-breadcrumb-inner { padding: 0 32px; }
    .utr-inner            { padding: 0 32px; }
    .utr-main-section     { padding: 48px 0 60px 0; }
    .utr-main-row         { flex-direction: column; gap: 48px; }
    .utr-sidebar          { flex: none; width: 100%; }
    .utr-article-title    { font-size: 20px; }
  }

  /* ══ RESPONSIVE — MOBILE ══ */
  @media (max-width: 480px) {
    .utr-hero             { height: 360px; }
    .utr-hero-content     { padding: 0 16px; }
    .utr-hero-title       { font-size: 24px; margin-bottom: 15px; }
    .utr-hero-divider     { width: 100%; }
    .utr-hero-subtitle    { font-size: 14px; }
    .utr-breadcrumb       { padding: 30px 0 0 0; }
    .utr-breadcrumb-inner { padding: 0 16px; }
    .utr-bc-item          { font-size: 14px; gap: 14px; }
    .utr-bc-sep           { width: 18px; height: 18px; margin: 0 4px; }
    .utr-bc-sep img       { width: 22px; height: 22px; }
    .utr-inner            { padding: 0 16px; }
    .utr-main-section     { padding: 30px 0 60px 0; }
    .utr-main-row         { flex-direction: column; gap: 60px; }
    .utr-sidebar          { flex: none; width: 100%; }
    .utr-article-title    { font-size: 20px; margin-bottom: 15px; }
    .utr-article-body     { font-size: 14px; }
    .utr-article-body p   { margin-bottom: 15px; }
    .utr-article-body ol  { margin: 0 0 20px 0; gap: 15px; }
    .utr-article-body ol li { font-size: 14px; }
    .utr-meta-item        { font-size: 14px; }
    .utr-article-img      { margin: 30px 0 15px 0; height: 250px; }
    .utr-h2               { font-size: 16px; margin: 30px 0 0px 0; }
    .utr-nav-btn img      { width: 24px; height: 24px; }
    .utr-nav-btn          { font-size: 14px; }
    .utr-share-icon img   { width: 34px; height: 34px; }
    .utr-sidebar-title    { font-size: 20px; }
  }
`;

const recentPosts = [
  {
       img: RecentImg1,
       title: "Battery Formation & Testing: Enabling The Rise Of EV & Energy Storage Manufacturing",
       slug: "battery-formation-testing-enabling-the-rise-of-ev-energy-storage-manufacturing/",
     },
     {
       img: RecentImg2,
       title: "Next-Gen ESP Power Supplies: Upgrades and Sustainability in Industrial Air Pollution Control",
       slug: "next-gen-esp-power-supplies-upgrades-and-sustainability-in-industrial-air-pollution-control/",
     },
     {
       img: RecentImg3,
       title: "Green Hydrogen Power Electronics: Ador Powertron at the Forefront of Electrolyzer Rectifier Setups",
       slug: "green-hydrogen-power-electronics-ador-powertron-at-the-forefront-of-electrolyzer-rectifier-setups/",
     },
     {
       img: RecentImg4,
       title: "Transformer Bushings: Types & Importance",
       slug: "transformer-bushings-guide/",
     },
];

export default function UpgradingTransformerRectifierSystems() {
  return (
    <div className="utr">
      <style>{CSS}</style>

      {/* ══ HERO ══ */}
      <section className="utr-hero">
        <img className="utr-hero-bg" src={HeroBgImg} alt="Upgrading Transformer Rectifier Hero" />
        <div className="utr-hero-overlay" />
        <div className="utr-hero-content">
          <h1 className="utr-hero-title">
            Why Upgrading Your ESP's Transformer Rectifier System Makes Business Sense
          </h1>
          <hr className="utr-hero-divider" />
          <p className="utr-hero-subtitle">
            Everything we do is designed, whether we're producing a magazine, a website, or a bridge. Design is really the creative invention that designs everything.
          </p>
        </div>
      </section>

      {/* ══ BREADCRUMB ══ */}
      <nav className="utr-breadcrumb" aria-label="Breadcrumb">
        <div className="utr-breadcrumb-inner">
          <a href="/" className="utr-bc-item">Home</a>
          <span className="utr-bc-sep"><img src={BcSepIcon} alt="" /></span>
          <a href="/news" className="utr-bc-item">News &amp; Updates</a>
          <span className="utr-bc-sep"><img src={BcSepIcon} alt="" /></span>
          <span className="utr-bc-item active">Post</span>
        </div>
      </nav>

      {/* ══ MAIN ══ */}
      <section className="utr-main-section">
        <div className="utr-inner">
          <div className="utr-main-row">

            {/* ── ARTICLE ── */}
            <article className="utr-article">

              {/* Meta bar */}
              <div className="utr-meta-bar">
                <span className="utr-meta-item"><img src={ProfileIcon} alt="author" /> Admin</span>
                <span className="utr-meta-item"><img src={CalendarIcon} alt="date" /> January 24, 2025</span>
                <span className="utr-meta-item"><img src={ClockIconImg} alt="time" /> 6:49 am</span>
                <span className="utr-meta-item"><img src={CommentsIcon} alt="comments" /> No Comments</span>
              </div>

              {/* Title */}
              <h1 className="utr-article-title">
                Why Upgrading Your ESP's Transformer Rectifier System Makes Business Sense
              </h1>

              {/* Body */}
              <div className="utr-article-body">

                <p>In the power, cement and steel industries, attaining optimal performance while satisfying strict environmental measures is a continuous challenge. A critical part of the electrostatic precipitator (ESP) is the <strong>transformer rectifier (T/R) system</strong>, which is essential to collect particulate matter effectively. Upgrading this system delivers numerous advantages beyond regulatory compliance—a strategic shift that can alter your operations.</p>

                {/* Article image */}
                <img className="utr-article-img" src={ArticleImg} alt="Upgrading Transformer Rectifier System" />

                <p>Upgrading your ESP's T/R system is an intelligent business decision.</p>

                <ol>
                  <li><span><strong>Improved ESP Efficiency and Reliability</strong><br />
                  Older T/R systems often need help maintaining the voltage and current levels required for effective particle collection. An upgrade enhances voltage control and increases collection efficiency, ensuring your ESP performs optimally even in challenging conditions. Modern systems are designed for reliability, decreasing the chance of breakdowns and lengthening the lifespan of your ESP. This implies periodic disturbances and smoother business operations.</span></li>

                  <li><span><strong>Lower Energy Consumption</strong><br />
                  Energy-intensive enterprises are continually striving for methods to lower functional expenses. Upgraded transformer rectifier systems are more energy-efficient, delivering accurate control that underestimates wastage. It translates to lower electricity bills while maintaining superior performance. Energy savings from upgraded systems can quickly offset the initial investment.</span></li>

                  <li><span><strong>Compliance with Environmental Standards</strong><br />
                  With increasingly stringent regulations, updated T/R systems may need to meet current emission standards. An upgrade guarantees compliance with existing regulations and organizes your company for future regulations. Efficient particulate collection lowers your environmental impression, defending your enterprise reputation while evading penalties or functional delays.</span></li>

                  <li><span><strong>Decreased Maintenance Expenses</strong><br />
                  Aging systems need periodic repairs and supervision, leading to unwarranted downtime and costs. Upgrading your T/R system reduces the risk of unexpected failures, minimizes upkeep costs and enhances uptime. Current systems are built with durability, require less intervention, and guarantee reliable performance.</span></li>

                  <li><span><strong>Readying for the Future</strong><br />
                  Upgraded T/R systems often come with advanced technology, enabling automation and control software integration. This prepares your ESP for future innovations like remote monitoring, predictive maintenance, and enhanced control systems. Staying ahead of the curve ensures long-term value and adaptability to evolving industry needs.</span></li>
                </ol>

                <span className="utr-h2">Conclusion: Partnering with ADOR Powertron for Optimal Results</span>

                <p>While the benefits of upgrading your ESP's Transformer Rectifier (T/R) system are clear, choosing the right provider is crucial to maximizing these advantages. ADOR Powertron Ltd., a global leader in Transformer Rectifier systems, offers unmatched expertise and innovative solutions.</p>

                <p>With over 35 years of experience, a presence in 82 countries, and 20,000+ high-voltage T/R units supplied, ADOR ensures reliable voltage regulation and optimized performance for industries handling a wide range of applications. From single-phase to complex industrial setups, ADOR's solutions effectively manage power generated, supporting the power, cement, steel, and paper industries.</p>

                <p>With a commitment to excellence, ADOR Powertron is the trusted choice for businesses seeking efficiency, compliance, and long-term reliability in their emission control systems.What sets ADOR apart is its commitment to quality and sustainability. Its ISO 9001 certification, in-house and OEM software integration capabilities, and strategic partnership with Redkoh ensure that its solutions deliver both performance and compliance.</p>

                <p>Invest in the future of your business with ADOR's advanced <a href="/news/transformer-rectifiers-coal-power" className="utr-red-link">Transformer Rectifier</a> systems.</p>

                <p><strong>Take the next step toward efficiency and sustainability. Contact ADOR Powertron today.</strong></p>

              </div>

              {/* ── Bottom row ── */}
              <div className="utr-bottom-row">
                <div className="utr-bottom-nav">
                   <a href="/news/5-signs-you-need-to-replace-your-esp-mechanical-spares/" className="utr-nav-btn" >
                                      <img src={PreviousIcon} alt="Previous" />
                                      Previous
                                    </a>
                                    <a href="/news/role-transformer-bushings-safe-power-transmission" className="utr-nav-btn" > 
                                      Next
                                      <img src={NextIcon} alt="Next" />
                                    </a>
                </div>
                <div className="utr-share-icons">
                  <a href="https://www.facebook.com/sharer.php?u=https://adorpowertron.com/why-upgrading-your-esps-transformer-rectifier-system-makes-business-sense/" className="utr-share-icon" aria-label="Facebook" target="blank">
                    <img src={FacebookIcon} alt="Facebook" />
                  </a>
                  <a href="https://x.com/i/jf/onboarding/web?redirect_after_login=%2Fintent%2Ftweet%3Ftext%3D%2520https%3A%2F%2Fadorpowertron.com%2Fwhy-upgrading-your-esps-transformer-rectifier-system-makes-business-sense%2F&mode=login" className="utr-share-icon" aria-label="Twitter" target="blank">
                    <img src={TwitterIcon} alt="Twitter" />
                  </a>
                  <a href="https://x.com/i/jf/onboarding/web?redirect_after_login=%2Fintent%2Ftweet%3Ftext%3D%2520https%3A%2F%2Fadorpowertron.com%2Fwhy-upgrading-your-esps-transformer-rectifier-system-makes-business-sense%2F&mode=login" className="utr-share-icon" aria-label="LinkedIn" target="blank">
                    <img src={LinkedinShareIcon} alt="LinkedIn" />
                  </a>
                </div>
              </div>

            </article>

            {/* ── SIDEBAR ── */}
            <aside className="utr-sidebar">

              {/* Recent Posts */}
              <div className="utr-sidebar-block">
                <p className="utr-sidebar-title">Recent Posts</p>
                <div className="utr-recent-list">
                  {recentPosts.map((post, idx) => (
                    <a key={idx} href={`/news/${post.slug}`} className="utr-recent-item">
                      <img src={post.img} alt={post.title} className="utr-recent-img" />
                      <div className="utr-recent-body">
                        <span className="utr-recent-title">{post.title}</span>
                      </div>
                    </a>
                  ))}
                </div>
              </div>

              {/* Social Media */}
              <div className="utr-sidebar-block">
                <p className="utr-sidebar-title">Social Media</p>
                <div className="utr-social-icons">
                  <a href="https://www.youtube.com/@adorIndia" className="utr-social-icon" aria-label="YouTube" target="blank">
                    <img src={YoutubeIcon} alt="YouTube" />
                  </a>
                  <a href="https://www.linkedin.com/uas/login?session_redirect=https%3A%2F%2Fwww.linkedin.com%2Fcompany%2F139191%2Fadmin%2F" className="utr-social-icon" aria-label="LinkedIn" target="blank">
                    <img src={LinkedinIcon} alt="LinkedIn" />
                  </a>
                </div>
              </div>

            </aside>

          </div>
        </div>
      </section>

    </div>
  );
}